import { BehaviorSubject, EMPTY, Subject, from } from 'rxjs'
import { debounceTime, finalize, switchMap, tap } from 'rxjs/operators'
import type { SearchApiService } from './SearchApiService'
import type { SearchInput, SearchResult } from '@/generated/graphql'

export class SearchService {
  readonly results$ = new BehaviorSubject<SearchResult[]>([])
  readonly isLoading$ = new BehaviorSubject(false)
  private readonly input$ = new Subject<SearchInput | null>()

  constructor(private readonly searchApiService: SearchApiService) {
    this.input$
      .pipe(
        debounceTime(220),
        switchMap((input) => {
          if (!input?.query.trim()) {
            this.results$.next([])
            this.isLoading$.next(false)
            return EMPTY
          }
          this.isLoading$.next(true)
          return from(this.searchApiService.search(input)).pipe(
            tap((res) => {
              if (res.isSuccess()) this.results$.next(res.result)
            }),
            finalize(() => this.isLoading$.next(false)),
          )
        }),
      )
      .subscribe()
  }

  search(input: SearchInput | null) {
    this.input$.next(input)
  }

  clear() {
    this.results$.next([])
    this.input$.next(null)
  }
}
